import { FaWhatsapp, FaTimes } from "react-icons/fa";
import { useState } from "react";

export default function WhatsAppButton() {
    const [showMessage, setShowMessage] = useState(false);

    const phoneNumber = "971502477593";

    const message = encodeURIComponent(
        "Hello, I would like to know more about your hotel deals."
    );

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <div className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[9999]">

            {/* Message */}
            <div
                className={`
                    absolute right-0 bottom-[72px]
                    w-[260px]
                    bg-white
                    rounded-2xl
                    shadow-[0_15px_40px_rgba(15,23,42,0.18)]
                    border border-slate-100
                    p-4
                    transition-all duration-300
                    origin-bottom-right
                    ${showMessage
                        ? "opacity-100 scale-100 translate-y-0"
                        : "opacity-0 scale-95 translate-y-2 pointer-events-none"
                    }
                `}
            >
                {/* Close */}
                <button
                    onClick={() => setShowMessage(false)}
                    className="absolute top-3 right-3 text-slate-400 hover:text-slate-700"
                >
                    <FaTimes size={12} />
                </button>

                <div className="flex items-center gap-3">

                    <div className="w-10 h-10 rounded-xl bg-[#25D366]/10 flex items-center justify-center shrink-0">
                        <FaWhatsapp className="text-[#25D366] text-xl" />
                    </div>

                    <div>
                        <p className="font-bold text-slate-900 text-sm">
                            Need Help?
                        </p>

                        <p className="text-xs text-slate-500 mt-1">
                            Chat with our travel team
                        </p>
                    </div>

                </div>

                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
        mt-4
        w-full
        flex
        items-center
        justify-center
        gap-2
        bg-[#25D366]
        hover:bg-[#20bd5a]
        text-white
        py-2.5
        rounded-xl
        text-sm
        font-semibold
        transition
    "
                >
                    <FaWhatsapp />
                    Chat on WhatsApp
                </a>
            </div>

            {/* Floating Button */}
            <div className="relative">

                {/* Pulse */}
                <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>

                <button
                    onClick={() => setShowMessage((prev) => !prev)}
                    aria-label="Contact us on WhatsApp"
                    className="
                        relative
                        w-14 h-14
                        sm:w-16 sm:h-16
                        rounded-full
                        bg-[#25D366]
                        text-white
                        flex
                        items-center
                        justify-center
                        shadow-[0_10px_30px_rgba(37,211,102,0.35)]
                        hover:scale-110
                        hover:shadow-[0_15px_35px_rgba(37,211,102,0.45)]
                        transition-all
                        duration-300
                    "
                >
                    <FaWhatsapp className="text-3xl sm:text-[34px]" />
                </button>

            </div>

        </div>
    );
}